import PropTypes from 'prop-types';
import React from 'react';

import { Anchor } from '../anchor/anchor';
import { Picture } from '../picture/picture';

const Logo = (props) => {
    const { elementProps } = props;
    return (
        <Anchor href={elementProps.href} data-id="ctmLogo">
            <Picture elementProps={elementProps} />
        </Anchor>
    );
};

Logo.propTypes = {
    elementProps: PropTypes.shape({
        href: PropTypes.string.isRequired
    }).isRequired
};

export { Logo };
